// import React, { useState, useEffect } from "react";
// import { MdVideocam } from "react-icons/md";
// import { Link } from "react-router-dom";
// import { format, parse, isBefore, set } from "date-fns";
// import axios from "axios";
// import BaseUrl from "../../Components/BaseUrl";
// import Cookies from "js-cookie";
// const EventList = () => {
//   const [isloading, setIsloading] = useState(false);
//   const [events, setEvents] = useState([]);
//   const [eventCount, setEventCount] = useState(0);  

//   useEffect(() => {
//     getEvents();
//   }, []);

//   const getEvents = async () => {
//     try {
//       setIsloading(true);
//       const response = await axios.get(BaseUrl + "getEvents", {
//         headers: {
//           Authorization: `Bearer ${Cookies.get("token")}`,
//         },
//       });
//       if (response.data.status === 200) {
//         setEvents(response.data.data.data);
//         setEventCount(response.data.data.total);
//         setIsloading(false);
//       }
//     } catch (error) {
//       console.log(error);
//       setIsloading(false);
//     }
//   };
//   const formatDateTime = (startDate, startTime, endDate, endTime, timezone) => {
//     try {
//       const startDateTime = parse(
//         `${startDate} ${startTime}`,
//         "yyyy-MM-dd HH:mm:ss",
//         new Date()
//       );
//       const endDateTime = parse(
//         `${endDate} ${endTime}`,
//         "yyyy-MM-dd HH:mm:ss",
//         new Date()
//       );

//       const formattedStart = format(startDateTime, "EEE, MMM d, yyyy, h:mm a");
//       const formattedEnd = format(endDateTime, "h:mm a");

//       return `${formattedStart} - ${formattedEnd}`;
//     } catch (error) {
//       console.error("Error formatting date:", error);
//       return "Invalid Date";
//     }
//   };
//   return (
//     <>
//       {isloading ? (
//         <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
//           <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
//         </div>
//       ) : (
//         <div className="bg-[#F3F2EF] mt-12 ">
//           <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
//             <div className="w-full lg:w-3/4 min-h-screen ">
//               <div className="bg-white border border-gray-300 rounded-lg mb-4">
//                 <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                   <p className="text-xl font-normal">Events</p>
//                   {/* <p className="text-blue-600 hover:bg-blue-100 hover:text-blue-900 px-4 py-2 rounded-lg">
//                     Create
//                   </p> */}
//                 </div>
//                 <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                   <p className="text-sm text-gray-700">{eventCount} Events</p>
//                 </div>
//                 {/* {events.map((event,index) => (
//                   <div key={index} className="">
//                   <Link
//                     to="/events/eventdetail"
//                     className="flex items-center space-x-4 p-4"
//                   >
//                     <img
//                       src="/Images/Events/dummy-img.png"
//                       className="w-24 h-16 rounded-lg object-contain"
//                     />
//                     <div className="flex flex-col items-start ">
//                       <p className=" leading-5 hover:underline">
//                         {event.event_name}{" "}
//                         {event.is_organizer && (
//                           <span className="ml-21 text-gray-600">
//                           {" "}
//                           • Organizer
//                         </span>
//                         )}
//                       </p>
//                       <p className="text-[12px] text-gray-600 text-center">
//                         {" "}
//                         <span className="mr-2">Past •</span>
//                         Tue, Apr 1, 2025, 1:00 PM - 2:00 PM
//                       </p>
//                       <p className="flex items-center text-xs text-gray-600 gap-1">
//                         <span className="flex items-center gap-1">
//                           <MdVideocam size={16} className="text-gray-700" />
//                           Online
//                         </span>
//                         <span className="text-gray-400">•</span>
//                         <span>By Shivam Mantri</span>
//                       </p>
//                     </div>
//                   </Link>
//                 </div>
//                 ))} */}
//                 {events.length > 0 ? (
//                   events.map((event, index) => {
//                     const { formatted, endDateTime } = formatDateTime(
//                       event.start_date,
//                       event.start_time,
//                       event.end_date,
//                       event.end_time,
//                       event.timezone
//                     );
//                     const isPast = isBefore(endDateTime, new Date());
//                     return (
//                       <div key={index} className="">
//                         <Link
//                           to={`/events/${event.slug}`}
//                           className="flex items-center space-x-4 p-4"
//                         >
//                           <img
//                             src={event.image || "/Images/Events/dummy-img.png"}
//                             className="w-24 h-16 rounded-lg object-contain"
//                             alt={event.event_name}
//                           />
//                           <div className="flex flex-col items-start">
//                             <p className="leading-5 hover:underline">
//                               {event.event_name}{" "}
//                               {event.is_organizer && (
//                                 <span className="ml-2 text-gray-600">
//                                   • Organizer
//                                 </span>
//                               )}
//                             </p>
//                             <p className="text-[12px] text-gray-600 text-center">
//                               {isPast && <span className="mr-2">Past •</span>}
//                               {formatted} 
//                             </p>
//                             <p className="flex items-center text-xs text-gray-600 gap-1">
//                               <span className="flex items-center gap-1">
//                                 <MdVideocam
//                                   size={16}
//                                   className="text-gray-700"
//                                 />
//                                 {event.event_type.charAt(0).toUpperCase() +
//                                   event.event_type.slice(1)}
//                               </span>
//                               <span className="text-gray-400">•</span>
//                               <span>By Shivam Mantri</span>
//                             </p>
//                           </div>
//                         </Link>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <div className="p-4">
//                     <p className="text-gray-600">No events found.</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <div className="w-full lg:w-1/4 "></div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default EventList;
import React, { useState, useEffect } from "react";
import { MdVideocam } from "react-icons/md";
import { MdLocationOn } from "react-icons/md";
import { Link } from "react-router-dom";
import { format, parse, isBefore, isAfter, isWithinInterval } from "date-fns";
import axios from "axios";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";

const EventList = () => {
  const [isloading, setIsloading] = useState(false);
  const [events, setEvents] = useState([]);
  const [eventCount, setEventCount] = useState(0);

  useEffect(() => {
    getEvents();
  }, []);

  const getEvents = async () => {
    try {
      setIsloading(true);
      const response = await axios.get(BaseUrl + "getEvents", {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      if (response.data.status === 200) {
        setEvents(response.data.data.data);
        setEventCount(response.data.data.total);
        setIsloading(false);
      }
    } catch (error) {
      console.log(error);
      setIsloading(false);
    }
  };

  const formatDateTime = (startDate, startTime, endDate, endTime, timezone) => {
    try {
      const startDateTime = parse(
        `${startDate} ${startTime}`,
        "yyyy-MM-dd HH:mm:ss",
        new Date()
      );
      const endDateTime = parse(
        `${endDate} ${endTime}`,
        "yyyy-MM-dd HH:mm:ss",
        new Date()
      );

      const formattedStart = format(startDateTime, "EEE, MMM d, yyyy, h:mm a");
      const formattedEnd = format(endDateTime, "h:mm a");

      // Determine event status
      const now = new Date();
      let status = "Upcoming";
      if (isBefore(endDateTime, now)) {
        status = "Past";
      } else if (isWithinInterval(now, { start: startDateTime, end: endDateTime })) {
        status = "Ongoing";
      }

      return {
        formatted: `${formattedStart} - ${formattedEnd}`,
        startDateTime,
        endDateTime,
        status,
      };
    } catch (error) {
      console.error("Error formatting date:", error);
      return {
        formatted: "Invalid Date",
        startDateTime: null,
        endDateTime: null,
        status: "Unknown",
      };
    }
  };

  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-12">
          <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-3/4 min-h-screen">
              <div className="bg-white border border-gray-300 rounded-lg mb-4">
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                  <p className="text-xl font-normal">Events</p>
                </div>
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                  <p className="text-sm text-gray-700">{eventCount} Events</p>
                </div>
                {events.length > 0 ? (
                  events.map((event, index) => {
                    const { formatted, status } = formatDateTime(
                      event.start_date,
                      event.start_time,
                      event.end_date,
                      event.end_time,
                      event.timezone
                    );
                    return (
                      <div key={index} className="">
                        <Link
                          to={`/events/${event.slug}`}
                          className="flex items-center space-x-4 p-4"
                        >
                          <img
                            src={event.image || "/Images/Events/dummy-img.png"}
                            className="w-24 h-16 rounded-lg object-contain"
                            alt={event.event_name}
                          />
                          <div className="flex flex-col items-start">
                            <p className="leading-5 hover:underline">
                              {event.event_name}{" "}
                              {event.is_organizer && (
                                <span className="ml-2 text-gray-600">
                                  • Organizer
                                </span>
                              )}
                            </p>
                            <p className="text-[12px] text-gray-600 text-center">
                              <span className="mr-2">{status} •</span>
                              {formatted}
                            </p>
                            {event.event_type === "online" ? (
                              <p className="flex items-center text-xs text-gray-600 gap-1">
                              <span className="flex items-center gap-1">
                                <MdVideocam
                                  size={16}
                                  className="text-gray-700"
                                />
                                {event.event_type.charAt(0).toUpperCase() +
                                  event.event_type.slice(1)}
                              </span>
                              <span className="text-gray-400">•</span>
                              <span>
                                By {event.created_by_name || "Unknown Organizer"}
                              </span>
                            </p>
                            ):(
                              <p className="flex items-center text-xs text-gray-600 gap-1">
                              <span className="flex items-center gap-1">
                              <MdLocationOn size={16} className="text-gray-700" />

                                {event.venue + ", " +
                                  event.address}
                              </span>
                              <span className="text-gray-400">•</span>
                              <span>
                                By {event.created_by_name || "Unknown Organizer"}
                              </span>
                            </p>
                            )}
                            
                          </div>
                        </Link>
                      </div>
                    );
                  })
                ) : (
                  <div className="p-4">
                    <p className="text-gray-600">No events found.</p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full lg:w-1/4"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default EventList;